/**
 * Formats a phone number string into (xxx) xxx-xxxx as the user types.
 * Strips all non-digit characters first, then applies formatting.
 * Limits to 10 digits (US format).
 *
 * @param {string} value - Raw input value
 * @returns {string} - Formatted phone string
 */
export const formatPhoneNumber = (value) => {
  // Strip everything that isn't a digit
  const digits = value.replace(/\D/g, '').slice(0, 10);

  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/**
 * Extracts just the digits from a formatted phone number.
 * Useful for validation and storage.
 *
 * @param {string} formatted - Formatted phone string like "(555) 123-4567"
 * @returns {string} - Just digits, e.g. "5551234567"
 */
export const getPhoneDigits = (value) => {
  return (value || '').replace(/\D/g, '');
};

/**
 * Validates a US phone number (must be exactly 10 digits).
 *
 * @param {string} value - Raw or formatted phone string
 * @returns {boolean}
 */
export const isValidUSPhone = (value) => {
  return getPhoneDigits(value).length === 10;
};
